import { z } from 'zod';
import { FindingStatusSchema, ResolvedReasonSchema } from './findings.js';
/**
 * Ručné prechody životného cyklu Findingu (ticket 11). Automatické prechody
 * (OPEN ↔ RESOLVED) robí matching; človek smie len:
 *
 *   OPEN ──▶ IGNORED | ACCEPTED_RISK      (vedomé rozhodnutie, prežije rescan)
 *   IGNORED ◀──▶ ACCEPTED_RISK             (zmena dôvodu)
 *   IGNORED | ACCEPTED_RISK ──▶ OPEN       (znovu otvoriť ručne)
 *
 * RESOLVED nález človek neotvára — ak sa komponent vráti do zraniteľného
 * rozsahu, otvorí ho matching sám (ADR 0007).
 */
export const ManualFindingStatusSchema = z.enum(['OPEN', 'IGNORED', 'ACCEPTED_RISK']);
export const FINDING_NOTE_MAX_LENGTH = 500;
export const SetFindingStatusSchema = z.object({
    status: ManualFindingStatusSchema,
    note: z.string().trim().max(FINDING_NOTE_MAX_LENGTH).optional(),
});
/** Povolené ručné prechody — jeden zdroj pravdy pre API (4xx) aj UI (ktoré tlačidlá ukázať). */
export const MANUAL_TRANSITIONS = {
    OPEN: ['IGNORED', 'ACCEPTED_RISK'],
    IGNORED: ['OPEN', 'ACCEPTED_RISK'],
    ACCEPTED_RISK: ['OPEN', 'IGNORED'],
    RESOLVED: [],
};
export function canTransition(from, to) {
    return MANUAL_TRANSITIONS[from].includes(to);
}
/** Odpoveď na zmenu stavu — minimálny tvar; celý riadok si UI znovu načíta. */
export const FindingStatusResultSchema = z.object({
    id: z.string(),
    status: FindingStatusSchema,
    note: z.string().nullable(),
    updatedAt: z.string(),
});
/**
 * Jedna udalosť životného cyklu. `actor` null = systém (matching po skene alebo
 * po zmene katalógu); `fromStatus` null = prvý výskyt.
 */
export const FindingEventViewSchema = z.object({
    id: z.string(),
    fromStatus: FindingStatusSchema.nullable(),
    toStatus: FindingStatusSchema,
    reason: ResolvedReasonSchema.nullable(),
    note: z.string().nullable(),
    createdAt: z.string(),
    actor: z.object({ id: z.string(), email: z.string() }).nullable(),
});
